export default "__VITE_ASSET__B3se7mqT__"